var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"title":_vm.error.statusCode,"status":String(_vm.error.statusCode),"sub-title":_vm.error.message}},[_c('template',{slot:"extra"},[_c('a',{key:"console",attrs:{"href":"/"}},[_vm._v("\n\t\t\tHome page\n\t\t")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }